export declare const ToFix: any;
export default ToFix;
export * from './src/fix';
